import React, { useState } from "react";

const ClubSocietyList = () => {
  const [clubs, setClubs] = useState([
    { id: 1, name: "XYZ Club" },
    { id: 2, name: "Rotaract Club" },
    { id: 3, name: "Rotaract Club" },
  ]);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedClub, setSelectedClub] = useState(null);

  const handleDelete = (id) => {
    const updatedClubs = clubs.filter((club) => club.id !== id);
    setClubs(updatedClubs);
    setShowDeleteModal(false);
    alert("Club/Society deleted successfully!");
  };

  const confirmDelete = (club) => {
    setSelectedClub(club);
    setShowDeleteModal(true);
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
    setSelectedClub(null);
  };

  const handleEdit = (id) => {
    alert(`Edit functionality for Club ID: ${id}`);
    // Navigate to the edit page or implement edit functionality
  };

  return (
    <div className="mx-5 mt-5">
      {/* Breadcrumb */}
      <div className="flex items-center text-[25px]">
        <span className="text-gray-400">Research & Student Life</span> / Student Life / 
        <p className="font-semibold">Clubs and Societies</p>
      </div>

      {/* Add and List Buttons */}
      <div className="flex items-center gap-3 mt-5">
        <button className="flex items-center gap-2 bg-gray-200 text-gray-700 px-4 py-2 rounded-lg">
          Add New
        </button>
        <button className="flex items-center gap-2 bg-[#6B1FBA] text-white px-4 py-2 rounded-lg">
          List Table
        </button>
      </div>

      {/* Table Section */}
      <div className="mt-8 bg-white shadow-md rounded-lg">
        <div className="p-4 text-[18px] font-semibold border-b">
          Club/Society List
        </div>
        <table className="w-full text-left border-collapse">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-6 py-4 border-b text-gray-700">Department Name</th>
              <th className="px-6 py-4 border-b text-gray-700">Actions</th>
            </tr>
          </thead>
          <tbody>
            {clubs.map((club) => (
              <tr key={club.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 border-b">{club.name}</td>
                <td className="px-6 py-4 border-b">
                  <div className="flex gap-4">
                    <button
                      className="bg-gray-200 text-gray-700 px-4 py-1 rounded-lg flex items-center gap-2"
                      onClick={() => confirmDelete(club)}
                    >
                      Delete
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                    <button
                      className="bg-purple-100 text-purple-700 px-4 py-1 rounded-lg flex items-center gap-2"
                      onClick={() => handleEdit(club.id)}
                    >
                      Edit
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15.232 5.232l3.536 3.536M9 11l6-6 3.536 3.536-6 6M4 20h16"
                        />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteModal && selectedClub && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-[500px] p-8 rounded-lg shadow-lg text-center">
            <h2 className="text-2xl font-bold mb-4 text-gray-800">Delete?</h2>
            <p className="text-gray-600 mb-4">
              Are you sure you want to delete this Club/Society?
            </p>
            <p className="font-semibold text-gray-800 mb-6">{selectedClub.name}</p>
            <div className="flex justify-center gap-4">
              <button
                className="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg"
                onClick={handleCancelDelete}
              >
                No
              </button>
              <button
                className="bg-[#6B1FBA] text-white px-4 py-2 rounded-lg"
                onClick={() => handleDelete(selectedClub.id)}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClubSocietyList;
